import React, { useContext, useState } from 'react';
import { DragSortingTable } from '../../components/DraggableTable/DraggingTable';

import {
  Button,
  Popconfirm,
  Col,
  Input,
  Row,
  Form,
  Modal,
  Upload,
  Divider,
  Image,
  message
} from 'antd';
import { PageHeader } from '@ant-design/pro-components';
import { RowProps } from 'antd/lib/row';
import { ColProps } from 'antd/lib/col';
import { observer } from 'mobx-react';
import {
  IfileUploadHookReturn,
  useFileUploadHook
} from 'hooks/FileUpload.hook';
import { rootContext } from 'stores';

import {
  DeleteFilled,
  QuestionCircleOutlined,
  UploadOutlined,
  EditOutlined
} from '@ant-design/icons';

import layout from 'antd/lib/layout';
import { useDebouncedCallback } from 'use-debounce';

const allowedType = ['image/jpeg', 'image/png', 'image/gif', 'image/svg+xml'];
const Parts: React.FC = observer(() => {
  const {
    StaticAssetStore: {
      state: {
        data: { videos, total, offset, limit },
        ui: { assetLoading }
      },
      getAllAsset,
      updateAsset,
      orderAsset,
      addAsset,
      deleteAsset
    }
  } = useContext(rootContext);
  console.log(videos, 90);
  const uploadSrc: IfileUploadHookReturn = useFileUploadHook(['video/mp4']);
  const uploadThumb: IfileUploadHookReturn = useFileUploadHook(allowedType);

  const [showModel, setShowModel] = useState<boolean>(false);
  const [search, setSearch] = useState<string>('');
  const [editMode, setEditMode] = useState<any>({});
  const [showVideo, setShowVideo] = useState<string | null>(null);

  const debounced = useDebouncedCallback(search => {
    getAllAsset(search, limit, offset, 'VIDEO');
  }, 800);

  const [editForm] = Form.useForm();
  const resetForm = () => {
    setShowModel(false);
    uploadThumb.onRemove();
    editForm.resetFields();
    uploadSrc.onRemove();
    setEditMode({});
  };
  const validations = (rule: any, value: any, callback: any) => {
    if (value && value?.trim()?.length === 0) {
      return Promise.reject('Whitespaces are not valid.');
    } else {
      return Promise.resolve();
    }
  };
  const rowProp: RowProps = {
    justify: 'space-around',
    align: 'stretch'
  };
  const colProp: ColProps = {
    span: 10,
    xs: 10
  };
  const cellStyle = {
    // display: 'inline-block',
    // width: '50px',
    // whiteSpace: 'nowrap',
    // overflow: 'hidden !important',
    // textOverflow: 'ellipsis'
  }
  return (
    <>
      <PageHeader>
        <Row justify="space-between">
          <Col>
            <Input.Search
              className="search_input_control"
              allowClear
              value={search}
              onChange={e => {
                setSearch(e.target.value);
                debounced(e.target.value);
              }}
              placeholder="Search"
            />
          </Col>
          <Col>
            <Button
              onClick={() => setShowModel(true)}
              type="link"
              className="primary_btn"
            >
              Upload New Video
            </Button>
          </Col>
        </Row>
      </PageHeader>
      <DragSortingTable
        draggedRow={(index, id) =>
          orderAsset({ index, id, assetType: 'VIDEO' })
        }
        className="Table_block_main"
        columns={[
          {
            title: 'Title(EN)',
            dataIndex: 'en_title',
            align: 'center',
            key: 'title',
            render: (value: string) => (
              <div style={cellStyle}>
                {value}
              </div>
            )
          },
          {
            title: 'Title(ZH)',
            dataIndex: 'zh_title',
            align: 'center',
            key: 'zh_title',
            render: (value: string) => (
              <div style={cellStyle}>
                {value}
              </div>
            )
          },
          {
            title: 'Thumbnail',
            dataIndex: 'thumb',
            align: 'center',
            key: 'thumb',
            render: value => (
              <div className="tableImage">
                <Image src={value} />
              </div>
            )
          },
          {
            title: 'Source',
            align: 'center',
            dataIndex: 'src',
            key: 'src',
            render: value => (
              <>
                <Button onClick={() => setShowVideo(value)}>Show</Button>
                {/* <div className="tableImage">
                  <video src={value} />
                </div> */}
              </>
            )
          },
          {
            title: 'Summary(EN)',
            align: 'center',
            dataIndex: 'en_summary',
            render: (value: string) => (
              <div style={cellStyle}>
                {value}
              </div>
            )
          },
          {
            title: 'Summary(ZH)',
            align: 'center',
            dataIndex: 'zh_summary',
            render: (value: string) => (
              <div style={cellStyle}>
                {value}
              </div>
            )
          },
          {
            title: 'Actions',
            align: 'center',
            render: (_: any, record: any) => (
              <div className="actionButtons">
                <Button
                  type="default"
                  className="editButton"
                  onClick={() => {
                    editForm.setFieldsValue(record);
                    setEditMode(record);
                    setShowModel(true);
                  }}
                >
                  <EditOutlined />
                </Button>

                <Popconfirm
                  autoAdjustOverflow
                  placement="topRight"
                  title={() => (
                    <p>
                      Delete this <b>video</b>{' '}
                      <span style={{ color: 'red' }}>Permanently</span> ?
                    </p>
                  )}
                  icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                  onConfirm={async () => {
                    await deleteAsset({ id: record?.id, assetType: 'VIDEO' });
                  }}
                >
                  <Button ghost={true} className="deleteButton">
                    <DeleteFilled />
                  </Button>
                </Popconfirm>
              </div>
            )
          }
        ]}
        loading={assetLoading}
        dataSource={videos}
        tableLayout="auto"
        rowKey="id"
        onChange={(pagination, _, sort) => {
          const { current = 1, pageSize = 10 } = pagination;
          getAllAsset(search, pageSize, current, 'VIDEO');
        }}
        pagination={{
          disabled: assetLoading,
          total: total,
          pageSize: limit,
          current: offset,
          showSizeChanger: true,
          pageSizeOptions: ['5', '10', '15', '20']
        }}
      />
      <Modal
        width="1000px"
        confirmLoading={assetLoading}
        visible={showModel}
        title={editMode?.id ? 'Edit Video' : 'Upload Video'}
        afterClose={() => {
          uploadSrc.onRemove();
          uploadThumb.onRemove();
          setEditMode({});
        }}
        onCancel={() => {
          setEditMode({});
          setShowModel(false);
          editForm.resetFields();
        }}
        onOk={editForm.submit}
        destroyOnClose={true}
      >
        <Form
          {...layout}
          form={editForm}
          onFinish={async values => {
            if (editMode?.id) {
              await updateAsset({
                id: editMode.id,
                ...values,
                ...(uploadSrc ? { src: uploadSrc.fileList[0] } : {}),
                ...(uploadThumb ? { thumb: uploadThumb.fileList[0] } : {}),
                assetType: 'VIDEO'
              });
            } else {
              if (!uploadThumb.fileList.length || !uploadSrc.fileList.length) {
                return message.error(
                  uploadSrc.fileList.length
                    ? 'Upload Thumbnail file'
                    : 'Upload Source file'
                );
              }
              await addAsset({
                ...values,
                src: uploadSrc.fileList[0],
                thumb: uploadThumb.fileList[0],
                assetType: 'VIDEO'
              });
            }
            resetForm();
          }}
        >
          <Row {...rowProp}>
            <Divider style={{ padding: '10px' }} orientation="left">
              <h3>Video & Thumbnail</h3>
            </Divider>
            <Col {...colProp}>
              <Form.Item
                label="Video"
                name="src"
                tooltip="File must be video file"
                rules={
                  !editMode?.id
                    ? [
                      {
                        required: true,
                        message: 'Please Upload Video'
                      }
                    ]
                    : []
                }
              >
                <Upload key="part_image" {...uploadSrc} accept="video/mp4">
                  <Button icon={<UploadOutlined />}>Click to upload</Button>
                </Upload>
              </Form.Item>
            </Col>
            <Col {...colProp}>
              <Form.Item
                label="Thumbnail"
                name="thumb"
                rules={
                  !editMode?.id
                    ? [
                      {
                        required: true,
                        message: 'Please Attach Thumbnail'
                      }
                    ]
                    : []
                }
              >
                <Upload
                  key="part_image"
                  {...uploadThumb}
                  accept="image/x-png,image/jpeg,image/jpg"
                >
                  <Button icon={<UploadOutlined />}>Click to upload</Button>
                </Upload>
              </Form.Item>
            </Col>
            <Divider style={{ padding: '10px' }} orientation="left">
              <h3>Video Title</h3>
            </Divider>
            <Col {...colProp}>
              <Form.Item
                label="Title(EN)"
                key="en_title"
                name="en_title"
                rules={
                  !editMode?.id
                    ? [
                      { required: true, message: 'Title (EN) is required' },
                      { validator: validations }
                    ]
                    : []
                }
              >
                <Input required />
              </Form.Item>
            </Col>

            <Col {...colProp}>
              <Form.Item
                label="Title(ZH)"
                key="zh_title"
                name="zh_title"
                rules={[{ validator: validations }]}
              >
                <Input type="text" />
              </Form.Item>
            </Col>
            <Divider style={{ padding: '10px' }} orientation="left">
              <h3>Video Description</h3>
            </Divider>

            <Col {...colProp}>
              <Form.Item
                label="Summary(EN)"
                key="en_summary"
                name="en_summary"
                rules={[
                  {
                    required: Boolean(!editMode?.id),
                    message: 'Summary (EN) is required'
                  },
                  { validator: validations }
                ]}
              >
                <Input.TextArea rows={5} />
              </Form.Item>
            </Col>

            <Col {...colProp}>
              <Form.Item
                label="Summary(ZH)"
                key="zh_summary"
                name="zh_summary"
                rules={[{ validator: validations }]}
              >
                <Input.TextArea rows={5} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      <Modal
        width="1000px"
        confirmLoading={assetLoading}
        visible={Boolean(showVideo)}
        onCancel={() => {
          setShowVideo(null);
          editForm.resetFields();
        }}
        footer={false}
        destroyOnClose={true}
      >
        {showVideo && (
          <div className="video-center">
            <video autoPlay width="720" height="440" controls>
              <source src={showVideo} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        )}
      </Modal>
    </>
  );
});

export default Parts;
